"use client";

import { useEffect, useMemo, useState } from "react";
import { cn } from "utils";
import { getSocialProofMockList } from "./socialProofMockData";

interface SocialProofItemProps {
  className?: string;
  /** 轮播间隔（ms），默认 3000 */
  interval?: number;
  /** 每次随机取样条数，默认 20 */
  limit?: number;
}

/**
 * 社交证明滚动条
 * 自动从 mock 数据中随机取样，每隔 interval ms 向上切换一条
 */
export const SocialProofItem = ({
  className,
  interval = 3000,
  limit = 20,
}: SocialProofItemProps) => {
  const list = useMemo(() => getSocialProofMockList(limit), [limit]);
  const [index, setIndex] = useState(0);
  const [animKey, setAnimKey] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % list.length);
      setAnimKey((prev) => prev + 1);
    }, interval);
    return () => clearInterval(timer);
  }, [list.length, interval]);

  const current = list[index];
  if (!current) {
    return null;
  }

  return (
    <div className={cn("flex items-center gap-1", className)}>
      <div className="w-1 h-1 rounded-full bg-content_brand_primary shrink-0" />
      <div className="relative overflow-hidden leading-none flex-1">
        <div key={animKey} className="animate-social-proof-slide-up">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1 min-w-0">
              <span className="body_bold_s text-content_primary">
                {current.user}
              </span>
              <span className="body_s text-content_tertiary truncate">
                {current.actionText}
              </span>
            </div>
            <span className="body_s text-content_tertiary shrink-0">
              {current.timeAgo}
            </span>
          </div>
        </div>
        <style jsx>{`
          @keyframes socialProofSlideUp {
            0% {
              transform: translateY(0);
              opacity: 1;
            }
            40% {
              transform: translateY(-100%);
              opacity: 0;
            }
            41% {
              transform: translateY(100%);
              opacity: 0;
            }
            100% {
              transform: translateY(0);
              opacity: 1;
            }
          }
          .animate-social-proof-slide-up {
            animation: socialProofSlideUp 0.4s ease-in-out;
          }
        `}</style>
      </div>
    </div>
  );
};
